module.exports = __webpack_public_path__ + "img/appIcon-menu--Invoicing.5b575bc3.svg";